import React, { useState } from "react";
import ConfirmBidModal from "../ConfirmBidModal/ConfirmBidModal";
import Loader from "../Loader/Loader";

interface BidInputProps {
  initialValue?: number;
  onSubmit: (
    amount: number,
    note?: string,
    flatRate?: boolean,
  ) => Promise<void> | void;
}

const BidInput: React.FC<BidInputProps> = ({ initialValue = 0, onSubmit }) => {
  const [inputValue, setInputValue] = useState<number | "">(
    initialValue > 0 ? initialValue : "",
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const openConfirm = () => {
    if (typeof inputValue !== "number" || !Number.isFinite(inputValue) || inputValue <= 0)
      return;
    setConfirmOpen(true);
  };

  const handleConfirm = async (note?: string, floatRate?: boolean) => {
    setIsSubmitting(true);
    try {
      await onSubmit(Number(inputValue), note, floatRate);
      setConfirmOpen(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitting && <Loader />}
      <div className="grid grid-cols-[1fr_auto] gap-2 mt-4">
        <input
          type="number"
          min={0}
          value={inputValue}
          onChange={(e) => {
            const val = e.target.value;
            setInputValue(val === "" ? "" : parseFloat(val));
          }}
          className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:ring [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
        <button
          onClick={openConfirm}
          disabled={
            isSubmitting ||
            typeof inputValue !== "number" ||
            !Number.isFinite(inputValue) ||
            inputValue <= 0
          }
          className="px-4 py-2 bg-primary text-white rounded text-sm hover:bg-primary-dark whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none"
        >
          Place Bid
        </button>
      </div>

      <ConfirmBidModal
        open={confirmOpen}
        amount={Number(inputValue) || 0}
        busy={isSubmitting}
        onCancel={() => (!isSubmitting ? setConfirmOpen(false) : void 0)}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default BidInput;
